import template from './footer.html';
class FooterComponent {

}


export default {
  template: template,
  controller: FooterComponent
};


// WEBPACK FOOTER //
// ./components/footer/footer.component.js